import type { PouchOperationActivityType } from '../enums/PouchOperationActivityType'
import type { PouchType } from '@/backend/market'

export class AccountantPouchOperationEntity {
  id?: string
  amount?: number
  dateTime?: string
  startDate?: string | null
  description?: string | null
  userId?: string | null
  userDisplayName?: string | null
  activityType?: PouchOperationActivityType
  roundDifference?: number
  counterpartyPouchId?: number | null
  counterpartyPouchType?: PouchType
  counterpartyDriverId?: number | null
  counterpartyDriverFullName?: string | null
  counterpartyUserId?: string | null
  counterpartyUserDisplayName?: string | null
}
